import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import merge from 'deepmerge'
import { dirname } from 'path'

import './theme.css'

export const phonerotheme: BrandTheme = merge<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'PHONERO',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'phonero',
      height: 28,
    },
  },
)
export default phonerotheme
